import React, {Component, useContext} from 'react'
import {Link} from 'react-router-dom'
import logo from '../../../../public/images/harnois-logo.svg'
import LangSwitcher from '../../components/Header/LangSwitcher'
import {withTranslation} from 'react-i18next'

class Header extends Component {

    constructor(props) {
        super(props);
    }
    render() {
        const {t} = this.props;
        const logoHtml = <img src={logo} alt={'Harnois ' + t('footer.energy')} title={'Harnois ' + t('footer.energy')}/>;
        return (
            <nav className="navbar navbar-expand-md navbar-light bg-white shadow-sm navbar-notlogged">
                <div className="container ">
                    <a className="navbar-brand" href="/">
                   {logoHtml}
                    </a>
                    <div className="" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item dropdown">
                                <LangSwitcher status="notlogged"/>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default withTranslation()(Header);
